// extracted by mini-css-extract-plugin
export default {"photoContainer":"HeaderPersonPhoto_photoContainer__ZAiIo"};